import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { useResponsive } from '~/client-flow/contexts';
import styles from './ClientFlowStructure.module.scss';
import { DesktopPane } from './DesktopPane/DesktopPane';
import { MobilePane } from './MobilePane/MobilePane';
export const ClientFlowStructure = (param)=>{
    let { children, hideBack, hideStepper, stepperSteps, activeStepIndex, onStepClick, completedSteps, activeSteps, testId } = param;
    const { relationship } = useCobConfig();
    const vendorDetails = relationship.vendor;
    const { isMobile, isDesktop } = useResponsive();
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, {
            [styles.mobile]: isMobile,
            [styles.desktop]: isDesktop
        }),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.paneContainer,
                children: isMobile ? /*#__PURE__*/ _jsx(MobilePane, {
                    vendorDetails: vendorDetails,
                    hideBack: hideBack,
                    hideStepper: hideStepper,
                    activeStepIndex: activeStepIndex,
                    onBackClick: onStepClick,
                    testId: testId
                }) : !hideStepper ? /*#__PURE__*/ _jsx(DesktopPane, {
                    stepperSteps: stepperSteps,
                    completedSteps: completedSteps,
                    activeSteps: activeSteps,
                    activeStepIndex: activeStepIndex,
                    onStepClick: onStepClick,
                    testId: testId
                }) : null
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.stepsContainer,
                children: children
            })
        ]
    });
};
